import { getRandomThing } from '@game-libs/exc-libs';
import { IntervalController } from '../controllers/interval-controller';

export enum BehaviorState {
  Center = 'Center',
  Left = 'Left',
  Right = 'Right',
  Roar = 'Roar',
}

export class DragonBehaviour {
  transitions: { [key in BehaviorState]: BehaviorState[] } = {
    [BehaviorState.Center]: [BehaviorState.Left, BehaviorState.Right],
    [BehaviorState.Left]: [BehaviorState.Center, BehaviorState.Right],
    [BehaviorState.Right]: [BehaviorState.Center, BehaviorState.Left],
    [BehaviorState.Roar]: [BehaviorState.Center],
  };

  actions: { [key in BehaviorState]?: () => void } = {};

  transitionClock = new IntervalController(() => {
    this.transitionToRandomNext();
  }, 1000);

  currentState: BehaviorState = BehaviorState.Center;

  setActions(actions: { [key in BehaviorState]: () => void }) {
    this.actions = actions;
  }

  transitionToForcedState(state: BehaviorState) {
    this.currentState = state;
    this.actions[this.currentState]?.();

    this.transitionClock.setInterval(2000);
  }

  transitionToRandomNext() {
    const possibleStates = this.transitions[this.currentState];

    if (possibleStates.length === 0) {
      return;
    }

    const idleAnimCycleLength = 200 * 4;

    const randomTimeouts = [
      { value: idleAnimCycleLength, probability: 10 },
      { value: 2 * idleAnimCycleLength, probability: 20 },
      { value: 3 * idleAnimCycleLength, probability: 30 },
      { value: 4 * idleAnimCycleLength, probability: 30 },
      { value: 5 * idleAnimCycleLength, probability: 10 },
    ];

    this.currentState = possibleStates[Math.floor(Math.random() * possibleStates.length)];

    const nextTimeout = getRandomThing(randomTimeouts);

    this.transitionClock.setInterval(nextTimeout);

    this.actions[this.currentState]?.();
  }
}
